
const config = {
    development: {
      API_BASE_URL: 'http://localhost:5000',
    },
    production: {
      API_BASE_URL: 'https://gid-backend.lusep.fi',
    },
};

const environment = 'production'; // development or production

export const AIS_URL = `${config[environment].API_BASE_URL}/api/ais?icao=`;
export const SIGMET_URL = `${config[environment].API_BASE_URL}/api/sigmet`;
export const METARS_URL = `${config[environment].API_BASE_URL}/api/metars`;
export const NOTAMS_URL = `${config[environment].API_BASE_URL}/api/notams`;
export const LOGIN_URL = `${config[environment].API_BASE_URL}/auth/vatsim`;
export const USER_URL = `${config[environment].API_BASE_URL}/api/user`;
export const LOGOUT_URL = `${config[environment].API_BASE_URL}/auth/logout`;
export const ATC_URL = `${config[environment].API_BASE_URL}/api/atc`;
export const WIKI_URL = `${config[environment].API_BASE_URL}/api/wiki/content-by-id`;
export const TRAFFIC_URL = `${config[environment].API_BASE_URL}/api/traffic`;
export const ATIS_URL = `${config[environment].API_BASE_URL}/api/atis`;

export const URL_START = `${config[environment].API_BASE_URL}`;

// Airports
export const orderedAirports = [
  { icao: "EFHK", name: "HELSINKI-VANTAA", latitude: 60.3170, longitude: 24.9580 },
  { icao: "EFET", name: "ENONTEKIÖ", latitude: 68.3645, longitude: 23.4275 },
  { icao: "EFHA", name: "HALLI", latitude: 61.8564, longitude: 24.7892 },
  { icao: "EFIV", name: "IVALO", latitude: 68.6108, longitude: 27.4139 },
  { icao: "EFJO", name: "JOENSUU", latitude: 62.6592, longitude: 29.6242 },
  { icao: "EFJY", name: "JYVÄSKYLÄ", latitude: 62.4008, longitude: 25.6728 },
  { icao: "EFKE", name: "KEMI-TORNIO", latitude: 65.7792, longitude: 24.5847 },
  { icao: "EFKI", name: "KAJAANI", latitude: 64.2842, longitude: 27.6875 },
  { icao: "EFKK", name: "KOKKOLA-PIETARSAARI", latitude: 63.7203, longitude: 23.1392 },
  { icao: "EFKS", name: "KUUSAMO", latitude: 65.9903, longitude: 29.2319 },
  { icao: "EFKT", name: "KITTILÄ", latitude: 67.6986, longitude: 24.8481 },
  { icao: "EFKU", name: "KUOPIO", latitude: 63.0086, longitude: 27.7944 },
  { icao: "EFLP", name: "LAPPEENRANTA", latitude: 61.0446, longitude: 28.1444 },
  { icao: "EFMA", name: "MARIEHAMN", latitude: 60.1222, longitude: 19.8983 },
  { icao: "EFMI", name: "MIKKELI", latitude: 61.6864, longitude: 27.2000 },
  { icao: "EFOU", name: "OULU", latitude: 64.9301, longitude: 25.3546 },
  { icao: "EFPO", name: "PORI", latitude: 61.4617, longitude: 21.7994 },
  { icao: "EFRO", name: "ROVANIEMI", latitude: 66.5648, longitude: 25.8304 },
  { icao: "EFSA", name: "SAVONLINNA", latitude: 61.9431, longitude: 28.9451 },
  { icao: "EFSI", name: "SEINÄJOKI", latitude: 62.6921, longitude: 22.8323 },
  { icao: "EFTP", name: "TAMPERE-PIRKKALA", latitude: 61.4141, longitude: 23.5878 },
  { icao: "EFTU", name: "TURKU", latitude: 60.5147, longitude: 22.2628 },
  { icao: "EFUT", name: "UTTI", latitude: 60.8964, longitude: 26.9383 },
  { icao: "EFVA", name: "VAASA", latitude: 63.0507, longitude: 21.7622 }
];
